<div class="row">
    <div class="col-sm-12" style="margin-left:15%;padding: 0px;">
        <button kendoButton (click)="onAddRow()" style="float: left;" [icon]="'add'" primary="false" title="Add">
            Add
        </button>

        <button kendoButton (click)="onRemoveSelected()" style="float: left; margin-left: 1%" [icon]="'delete'"
            primary="false" title="Remove Selected">
            Remove Selected
        </button>
    </div>
</div>
<ag-grid-angular #agGrid style="width:75%; height: 220px;text-align: left;margin-left:15%;"
    class="ag-theme-balham ag-grid-workflow" [columnDefs]="columnDefs" [rowData]="rowData" [rowSelection]="rowSelection"
    [frameworkComponents]="frameworkComponents" [defaultColDef]="defaultColDef" [rowDragManaged]="true"
    (cellEditingStopped)="onCellEditingStopped($event)" (gridReady)="onGridReady($event)">
</ag-grid-angular>